import React from 'react';
import { SectionHeader } from '../ui/Shared';
export function CreatorSection() {
  return <section id="creador" className="py-24" data-id="element-102">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-103">
        <SectionHeader tag="Sobre el autor" title={<>
              Quién diseñó este protocolo
              <br data-id="element-105" />y por qué funciona
            </>} data-id="element-104" />

        <div className="fade-up grid grid-cols-1 md:grid-cols-[340px_1fr] gap-10 md:gap-16 items-center mt-12" data-id="element-106">
          <div className="relative max-w-[280px] md:max-w-none mx-auto w-full" data-id="element-107">
            <img src="https://i.postimg.cc/FRmCJJBj/escritor.webp" alt="Hugo Pagano — Autor del Protocolo SOS Reflujo 11 PM" className="w-full aspect-[3/4] rounded-2xl border-2 border-accent/20 object-cover object-top" data-id="element-108" />
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-gradient-gold text-primary py-2 px-5 rounded-full text-xs font-extrabold whitespace-nowrap" data-id="element-109">
              Hugo Pagano — Autor
            </div>
          </div>

          <div className="pt-5 md:pt-0" data-id="element-110">
            <h3 className="font-playfair text-3xl font-black mb-2 text-text-light" data-id="element-111">
              Hugo Pagano
            </h3>
            <div className="text-[15px] font-semibold text-accent mb-6" data-id="element-112">
              Creador del Protocolo de Digestión Estructurada™
            </div>

            <div className="space-y-4 text-base text-text-muted leading-relaxed" data-id="element-113">
              <p data-id="element-114">
                Yo sé lo que es vivir con reflujo. No como dato de un libro —
                sino como el tipo que pasó años buscando respuestas entre
                pastillas, restricciones que se contradecían y noches rotas sin
                entender por qué nada funcionaba de forma sostenida.
              </p>
              <p data-id="element-115">
                Lo que faltaba no era otra lista de alimentos prohibidos. Lo que
                faltaba era{' '}
                <strong className="text-text-light" data-id="element-116">
                  orden. Un sistema. Una secuencia lógica.
                </strong>{' '}
                Eso es exactamente lo que desarrollé y documenté en Reflujo Cero
                en 72h.
              </p>
              <p data-id="element-117">
                Hoy, más de 850 personas han aplicado el{' '}
                <strong className="text-text-light" data-id="element-118">
                  Protocolo de Digestión Estructurada™
                </strong>{' '}
                con resultados documentados en reducción del ardor, mejora del
                sueño y recuperación del control digestivo.
              </p>
            </div>

            <div className="flex flex-wrap gap-2.5 mt-6" data-id="element-119">
              <span className="bg-accent/10 border border-accent/20 text-accent py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-120">
                +850 personas guiadas
              </span>
              <span className="bg-accent/10 border border-accent/20 text-accent py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-121">
                Protocolo probado
              </span>
              <span className="bg-accent/10 border border-accent/20 text-accent py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-122">
                Enfoque sin restricciones absurdas
              </span>
              <span className="bg-accent/10 border border-accent/20 text-accent py-1.5 px-3.5 rounded-full text-xs font-semibold" data-id="element-123">
                Resultados en 72h
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}